angular.module('smartorg.r6.mgmts.importPortfolio', []);
require('./import-portfolio-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.mgmts.importPortfolio';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/import-portfolio/app/js/plumbing/app.js